module.exports = __webpack_public_path__ + "media/customizations/dobsonranch/logo-efe3ebede27f234176803001073b6d6d.png";